import React, { useRef, useState, useEffect } from 'react'
import { getDatabase, ref, onValue, off} from "firebase/database";

// component
import Toast from './Toast'

// styles
import { WrapNotifyNewUser } from './index.styles'

// constant
import { refNotifyNewUser } from '../../../constant/host';
import { WEE_ENV, DEV_ENV, env } from '../../../constant/environmentTypes';

const TIME_SHOW = process.env.NODE_ENV === 'development' ? 5_000 : 20_000 // 20 secs


const NotifyNewUser = () => {
    let isFirst = true
    const timer = useRef(null)
    const isAllowNotification = useRef(false)
    const isFocusWindow = useRef(false)
    const [count, setCount] = useState(0);
    const [isShow, setIsShow] = useState(false);

    const _checkActiveTab = () => {
        const keys = ["hidden","webkitHidden","mozHidden","msHidden"]
        const stateKey = keys.find(key => key in document)
        return !document[stateKey];
    }

    const _getNotificationPermission = () => {
        if (!("Notification" in window)) {
            console.error("This browser does not support desktop notification");
            isAllowNotification.current = false
            return;
        }

        else if (Notification.permission === "granted") {
            isAllowNotification.current = true
            return;
        }

        else if (Notification.permission !== "denied") {
            Notification.requestPermission()
            .then(function (permission) {
                if (permission === "granted") {
                    isAllowNotification.current = true
                    return;
                }
                isAllowNotification.current = false
            });
            return;
        }
        // user not allow notification 
        console.log('User not allow notification')
        isAllowNotification.current = false
    }

    useEffect(_getNotificationPermission, []);

    const _notify = () => {
        const title = "Kiểm duyệt tài khoản"
        const options = {
            icon: "favicon.ico",
            body: "Khách hàng vừa đăng ký tài khoản, kiểm duyệt ngay nhé!"
        }
        const notification = new Notification(title, options)
        notification.onclick = function() {
            window.focus()
            this.close()
        }
        // notification.onerror = function() {
        //     console.log('error')
        // }
        // notification.onshow = function() {
        //     console.log('show')
        // }
    }

    useEffect(() => {
        if(![DEV_ENV, WEE_ENV].includes(env)) return;
        let startNewUser
        _startListenFirebaseNewUser(startNewUser)
        return () => {
            startNewUser && off(startNewUser)
        }
    }, []);

    const _startListenFirebaseNewUser = (startNewUser) => {
        // console.log(app)
        const db = getDatabase();
        // console.log(db)
        startNewUser = ref(db, refNotifyNewUser);
        // console.log(startDevice)
        onValue(startNewUser, (snapshot) => {
            // console.log(snapshot)
            // const data = snapshot.val();
            // console.log(data)
            // console.log(snapshot.key)
            if(isFirst){
                isFirst = false
                return
            }
            if(snapshot.key === 'Total'){
                // console.log(data.val());
                setCount(pre => pre + 1)
                setIsShow(true);
                // console.log('_checkActiveTab()', _checkActiveTab())
                // console.log('isFocusWindow.current', isFocusWindow.current)
                (!_checkActiveTab() || !(isFocusWindow.current || document.hasFocus())) && isAllowNotification.current && _notify()
            } else {
                console.log('child is not count key')
            }
        });
    }

    useEffect(() => {
        if(!isShow) return 
        clearTimeout(timer.current)
        timer.current = setTimeout(() => {
            setIsShow(false)
        }, TIME_SHOW)

        return () => {
            clearTimeout(timer.current)
        }
    }, [isShow, count]);
    
    useEffect(() => {
        // Active
        window.addEventListener('focus', () => {
            // console.log('focus')
            isFocusWindow.current = true
        });

        // Inactive
        window.addEventListener('blur', () => {
            // console.log('blur')
            isFocusWindow.current = false
        });

        window.addEventListener('mousemove', () => {
            // console.log('mousemove')
            !isFocusWindow.current && (isFocusWindow.current = true)
        });
        // window.addEventListener('mouseleave', () => {
        //     console.log('mouseleave')
        // });

        // document.addEventListener('visibilitychange',() => {
        //     console.log('hidden', document.hidden)
        // })
        window.focus()
    }, []);
    if(!isShow) return null
    return (
        <WrapNotifyNewUser>
            <Toast 
                isShow={isShow} 
            />
        </WrapNotifyNewUser>
    )
}

export default NotifyNewUser
